import { getShowAmexBanner } from "@faire/retailer-visitor-shared/serialized-data/getShowAmexBanner";
import { useSettingDecentralizePageData } from "@faire/retailer-visitor-shared/settings/useSettingDecentralizePageData";
import { useQuery as useShowAmexBannerQuery } from "@faire/web-api--source/endpoints/www/api/retailer/show-amex-credit-banner/get-hooks";

export const useShowAmexBanner = () => {
  const shouldDecentralizePageData = useSettingDecentralizePageData();
  const serializedShowAmexBanner = getShowAmexBanner();

  const { data: showAmexBannerData } = useShowAmexBannerQuery({
    enabled: shouldDecentralizePageData,
    refetchOnMount: false,
    staleTime: Infinity,
  });
  const showAmexBanner =
    showAmexBannerData?.show_banner ?? serializedShowAmexBanner;

  return { showAmexBanner };
};
